const rawQuests = [
  // 1. Deal Damage Quests
  {
    id: "quest_dealDamage_001",
    title: "Deal 20 Damage",
    description: "Deal a total of 10 damage across any number of matches.",
    type: "damage",
    goal: 20,
    reward: { xp: 50, tokens: 5 },
    completed: false,
    town: "Void City",
    timed: false,
  },
  {
    id: "quest_dealDamage_002",
    title: "Deal 40 Damage",
    description: "Deal a total of 25 damage across matches.",
    type: "damage",
    goal: 40,
    reward: { xp: 75, tokens: 8 },
    completed: false,
    town: "Void City",
    timed: false,
  },
  {
    id: "quest_dealDamage_003",
    title: "Deal 60 Damage",
    description: "Inflict 50 damage in total.",
    type: "damage",
    goal: 60,
    reward: { xp: 100, tokens: 12 },
    completed: false,
    town: "Void City",
    timed: false,
  },
  {
    id: "quest_dealDamage_004",
    title: "Deal 75 Damage",
    description: "Deal 75 damage in total.",
    type: "damage",
    goal: 75,
    reward: { xp: 130, tokens: 15 },
    completed: false,
    town: "Void City",
    timed: false,
  },
  {
    id: "quest_dealDamage_005",
    title: "Deal 100 Damage",
    description: "Accumulate 100 total damage.",
    type: "damage",
    goal: 100,
    reward: { xp: 150, tokens: 18 },
    completed: false,
    town: "Void City",
    timed: false,
  },
  {
    id: "quest_dealDamage_006",
    title: "Deal 150 Damage",
    description: "Total 150 damage dealt to enemies.",
    type: "damage",
    goal: 150,
    reward: { xp: 175, tokens: 20 },
    completed: false,
    town: "Void City",
    timed: false,
  },
  {
    id: "quest_dealDamage_007",
    title: "Deal 200 Damage",
    description: "Deal 200 points of damage over matches.",
    type: "damage",
    goal: 200,
    reward: { xp: 200, tokens: 25 },
    completed: false,
    town: "Void City",
    timed: false,
  },
  {
    id: "quest_dealDamage_008",
    title: "Deal 300 Damage",
    description: "Deal 300 total damage.",
    type: "damage",
    goal: 300,
    reward: { xp: 250, tokens: 30 },
    completed: false,
    town: "Void City",
    timed: false,
  },
  {
    id: "quest_dealDamage_009",
    title: "Deal 400 Damage",
    description: "Hit your enemies for 400 damage total.",
    type: "damage",
    goal: 400,
    reward: { xp: 300, tokens: 35 },
    completed: false,
    town: "Void City",
    timed: false,
  },
  {
    id: "quest_dealDamage_010",
    title: "Deal 500 Damage",
    description: "Deal 500 damage and prove your power.",
    type: "damage",
    goal: 500,
    reward: { xp: 400, tokens: 40 },
    completed: false,
    town: "Void City",
    timed: false,
  },

  // 2. Play Cards Quests
  ...[10, 25, 40, 60, 75, 100, 150, 200, 250, 300].map((goal, index) => ({
    id: `quest_playCards_${String(index + 1).padStart(3, "0")}`,
    title: `Play ${goal} Cards`,
    description: `Play a total of ${goal} cards in matches.`,
    type: "playCards",
    goal,
    reward: { xp: goal, tokens: Math.ceil(goal / 5) + 4 },
    completed: false,
    town: "Void City",
    timed: false,
  })),

  // 3. Play Card Type Quests (Health Only for this sample)
  ...[5, 10, 15, 20, 30, 40, 50, 60, 75, 100].map((goal, index) => ({
    id: `quest_playHealth_${String(index + 1).padStart(3, "0")}`,
    title: `Play ${goal} Health Cards`,
    description: `Play ${goal} cards of type 'Health'.`,
    type: "cardType",
    subtype: "Health",
    goal,
    reward: { xp: goal * 4, tokens: Math.ceil(goal / 2) + 3 },
    completed: false,
    town: "Void City",
    timed: false,
  })),

  // 4. Element Wins Quests (Fire Element example)
  ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((goal, index) => ({
    id: `quest_winFire_${String(index + 1).padStart(3, "0")}`,
    title: `Win ${goal} Match${goal > 1 ? "es" : ""} with Fire Character`,
    description: `Use a fire-element character to win ${goal} match${
      goal > 1 ? "es" : ""
    }.`,
    type: "elementWins",
    subtype: "fire",
    goal,
    reward: { xp: goal * 50, tokens: goal * 2 },
    completed: false,
    town: "Void City",
    timed: false,
  })),

  // 5. Rarity Wins Quests (Legendary Rarity example)
  ...[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((goal, index) => ({
    id: `quest_winCommon_${String(index + 1).padStart(3, "0")}`,
    title: `Win ${goal} Match${goal > 1 ? "es" : ""} with Common Character`,
    description: `Win ${goal} match${
      goal > 1 ? "es" : ""
    } using a Common character.`,
    type: "rarityWins",
    subtype: "Common",
    goal,
    reward: { xp: goal * 60, tokens: goal * 3 },
    completed: false,
    town: "Void City",
    timed: false,
  })),
];

export const starterQuests = rawQuests.map((quest) => {
  let difficulty = "easy";

  if (quest.type === "damage") {
    difficulty =
      quest.goal <= 100 ? "easy" : quest.goal <= 300 ? "medium" : "hard";
  }

  if (quest.type === "playCards") {
    difficulty =
      quest.goal <= 60 ? "easy" : quest.goal <= 150 ? "medium" : "hard";
  }

  if (quest.type === "cardType") {
    difficulty =
      quest.goal <= 20 ? "easy" : quest.goal <= 50 ? "medium" : "hard";
  }

  if (quest.type === "elementWins" || quest.type === "rarityWins") {
    difficulty = quest.goal <= 3 ? "easy" : quest.goal <= 7 ? "medium" : "hard";
  }

  return {
    ...quest,
    difficulty,
  };
});
